// ABOUTME: Shipment status label with a hover popover listing the shipper's tracking events.
// ABOUTME: Shows the current shipment status on the cards in the order sidepanel's shipments view.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import SHQuickAction from "../../../../theme/Modal/SHQuickAction";
import ShLabel from "../../../../theme/label/ShLabel";
import Text from "../../../../theme/text/Text";
import { getShipmentStatusLabeldata } from "../../../../../utils/labelColorText";

const ShipmentStatusLabel = ({ shipment }) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    if (!shipment?.shipmentStatus) return null;

    const { labelcolor, labeltext } = getShipmentStatusLabeldata(shipment.shipmentStatus, theme);

    const label = (
        <ShLabel size={32} fitted palette="normal" variant={labelcolor}>
            {t(labeltext)}
        </ShLabel>
    );

    if (!shipment.shipperEvents || shipment.shipperEvents.length === 0) {
        return label;
    }

    return (
        <SHQuickAction
            maxWidth={700}
            component={
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        pt: 2,
                        px: 2,
                    }}
                >
                    <Box
                        sx={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                        }}
                    >
                        <Text
                            bold
                            sx={{ width: "140px", flexShrink: 0 }}
                        >
                            {t("date")}
                        </Text>
                        <Text
                            bold
                            sx={{ width: "140px", flexShrink: 0 }}
                        >
                            {t("type")}
                        </Text>
                        <Text
                            bold
                            sx={{ minWidth: "350px", flexShrink: 0 }}
                        >
                            {t("status")}
                        </Text>
                    </Box>

                    {shipment.shipperEvents.map((event, index) => (
                        <Box
                            key={index + "event"}
                            sx={{
                                position: "relative",
                                minHeight: 40,
                                py: 1,
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                            }}
                        >
                            <Text sx={{ width: "140px", flexShrink: 0 }}>
                                {event.timeStamp ? new Date(event.timeStamp).toLocaleString(i18n.language) : "-"}
                            </Text>
                            <Text sx={{ width: "140px", flexShrink: 0 }}>
                                {event.type}
                            </Text>
                            <Text sx={{ minWidth: "350px", flexShrink: 0 }}>
                                {event.status}
                            </Text>
                        </Box>
                    ))}
                </Box>
            }
        >
            {({anchorEl, onMouseEnter, onMouseLeave, onTouchStart}) => (
                <Box
                    aria-owns={anchorEl ? "simple-popover" : undefined}
                    aria-haspopup="true"
                    onMouseEnter={onMouseEnter}
                    onMouseLeave={onMouseLeave}
                    onTouchStart={onTouchStart}
                    sx={{
                        display: "inline-flex",
                    }}
                >
                    {label}
                </Box>
            )}
        </SHQuickAction>
    );
};

export default ShipmentStatusLabel;
